import React, { useEffect } from "react";
import { connect } from "react-redux";

import history from "../../history";
import { getAdSmartlink } from "../../routes/Ad/ad.ducks";
import { selectModules } from "../App/selectors";

const RedirectingToAd = props => {
  useEffect(() => {
    const {
      location: { pathname },
      getAdSmartlink: getAd
    } = props;

    const oidPath = "/oid/"; // The path to chek old ad route
    const oidIndex = pathname.indexOf(oidPath);

    if (oidIndex >= 0) {
      const adCode = pathname.slice(oidIndex + oidPath.length, pathname.length);

      if (adCode) {
        getAd(adCode);

        return;
      }
    }

    if (!checkValidModule()) {
      history.replace("/not-found");
    }
  }, []);

  const checkValidModule = () => {
    const {
      modules,
      location: { pathname }
    } = props;

    let validRoute = false;

    modules.forEach(module => {
      if (String(pathname).startsWith(`/${module.route}`)) {
        validRoute = true;
      }
    });

    return validRoute;
  };

  return <h2 className="child-center">{"Preusmjeravanje..."}</h2>;
};

export default connect(
  state => ({
    modules: selectModules(state)
  }),
  {
    getAdSmartlink
  }
)(RedirectingToAd);



// WEBPACK FOOTER //
// ./src/containers/RedirectingToAd/index.tsx